(function() {
  'use strict';
  
  angular
    .module('plugins.free-text-response')
    .controller('FreeTextResponsePollEditController', FreeTextResponsePollEditController);
      
    FreeTextResponsePollEditController.$inject = [
    '$log', 
    '$scope', 
    'pollPluginService'
  ];
    
  function FreeTextResponsePollEditController($log, $scope, pollPluginService) {
    $log = $log.getInstance('FreeTextResponsePollEditController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.poll = $scope.poll;
    vm.questionChanged = questionChanged;
    
    activate();
    
    function activate() {
      // Support copying to clipboard
      vm.poll.toPlainText = toPlainText;
    }
    
    function questionChanged(poll) {
      poll.name = poll.data.question;
      pollPluginService.updatePoll(poll);
    }

    function toPlainText() {
      return vm.poll.data.question + '\n';
    }

  }
})();